
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.content-loading{
  padding:10px;
  border-radius:4px;
  height:125px;
  width:100%;
  margin-bottom:10px;
  position:relative;
}

.content-loading .content-loading__bars{
  display:block;
  position:absolute;
  top:50%;
  left:50%;
  height:50px;
  width:50px;
  margin:-25px 0 0 -25px;
}

.content-loading .content-loading__bars span{
  position:absolute;
  display:block;
  bottom:10px;
  width:9px;
  height:5px;
  background:rgba(0, 169, 238, 0.25);
  animation:bars1 1.5s infinite ease-in-out;
}

.content-loading .content-loading__bars span:nth-child(2){
  left:11px;
  animation-delay:0.2s;
}

.content-loading .content-loading__bars span:nth-child(3){
  left:22px;
  animation-delay:0.4s;
}

.content-loading .content-loading__bars span:nth-child(4){
  left:33px;
  animation-delay:0.6s;
}

.content-loading .content-loading__bars span:nth-child(5){
  left:44px;
  animation-delay:0.8s;
}

.text-center{
  text-align:center;
}

@keyframes bars1{
  0%{
    height:5px;
    transform:translateY(0px);
    background:rgba(0, 169, 238, 0.25);
  }

  25%{
    height:30px;
    transform:translateY(15px);
    background:#00a9ee;
  }

  50%{
    height:5px;
    transform:translateY(0px);
    background:rgba(0, 169, 238, 0.25);
  }

  100%{
    height:5px;
    transform:translateY(0px);
    background:rgba(0, 169, 238, 0.25);
  }
}

.content-loading h5{
  margin-top:90px;
  color:rgba(0, 169, 238, 0.8);
  font-size:1.5rem;
  font-family:'GothamNarrow-Medium', sans-serif;
  line-height:1.2;
}
`;